import { createContext, useContext } from "react";
import { ProductListEvent } from "./dispatchEvent";

type ProductListEventDispatcher = (event: ProductListEvent) => void;

export const ProductListEventContext =
  createContext<ProductListEventDispatcher | null>(null);

export const useProductListEventDispatcher = () => {
  const dispatch = useContext(ProductListEventContext);
  if (!dispatch) {
    throw new Error(
      "useProductListEventDispatcher must be used within a ProductListEventProvider",
    );
  }
  return dispatch;
};
